/**
 * Keeps a person on the agile pages of a project they can see ONLY through a
 * read-only agile grant (app_access.agile_read_only_projects, migration 00582).
 *
 * The grant opens the project's Backlog, Board, Sprints, Roadmap and Insights,
 * read-only. Any other page of that project (overview, schedule, finance, team,
 * risks, ...) redirects to the Backlog. Personal pages (home, My Work, profile,
 * the project list) stay open. No-op for everyone without such a grant. The
 * rule itself is resolveAgileOnlyRedirect (config/projectEntitlements).
 */

import { Navigate, useLocation } from 'react-router-dom'
import { useAppStore } from '@/store/appStore'
import { useProjectEntitlementStore, resolveAgileOnlyRedirect } from '@/config/projectEntitlements'

export function AgileOnlyRouteGuard({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation()
  const selectedId = useAppStore((s) => s.selectedProject?.id ?? null)
  const agileOnlyIds = useProjectEntitlementStore((s) => s.agileOnlyIds)
  const target = resolveAgileOnlyRedirect(pathname, selectedId, agileOnlyIds)
  if (target && target !== pathname) return <Navigate to={target} replace />
  return <>{children}</>
}
